/* ============================================================
   Product Compare — product-compare.js
   Vanilla JS · No dependencies · Multi-section safe · IIFE
   ============================================================ */
(function () {
  'use strict';

  /* ── Helpers ───────────────────────────────────────────── */
  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return el.querySelectorAll(sel); }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function tpl(str, n) { return str.replace(/\{n\}/g, n); }

  /* ── Section init ──────────────────────────────────────── */
  function initSection(section) {
    var sid       = section.dataset.sectionId;
    var cfg       = (window.pcConfig && window.pcConfig[sid]) || {};
    var minCmp    = parseInt(cfg.minCompare, 10) || 2;
    var maxCmp    = parseInt(cfg.maxCompare, 10) || 4;
    var rowLabels = cfg.rowLabels || {};
    var addMoreTpl  = cfg.addMoreText  || 'Add {n} more to compare';
    var selectedTpl = cfg.selectedText || '{n} selected';

    /* ── DOM refs ── */
    var chips         = qsa(section, '.pc-chip');
    var cards         = qsa(section, '.pc-card');
    var toggle        = qs(section,  '.pc-toggle');
    var bar           = qs(section,  '.pc-bar');
    var barThumbs     = bar && qs(bar, '.pc-bar__thumbs');
    var barInfo       = bar && qs(bar, '.pc-bar__info');
    var barClear      = bar && qs(bar, '.pc-bar__clear');
    var barCta        = bar && qs(bar, '.pc-bar__cta');
    var popup         = qs(section,  '.pc-popup');
    var popupBackdrop = popup && qs(popup, '.pc-popup__backdrop');
    var popupClose    = popup && qs(popup, '.pc-popup__close');
    var tableWrap     = popup && qs(popup, '.pc-popup__table-wrap');
    var emptyState    = qs(section, '.pc-empty');

    /* ── State ── */
    var activeTag   = '';
    var compareMode = toggle ? toggle.getAttribute('aria-checked') === 'true' : false;
    var selectedIds = [];   /* array of data-compare-id values */

    /* ── Filter chips ── */
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeTag = chip.dataset.tag || '';
        chips.forEach(function (c) {
          var hit = c === chip;
          c.classList.toggle('is-active', hit);
          c.setAttribute('aria-pressed', hit ? 'true' : 'false');
        });
        applyFilter();
      });
    });

    function applyFilter() {
      var visible = 0;
      cards.forEach(function (card) {
        var show = !activeTag || (card.dataset.tag || '') === activeTag;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (emptyState) emptyState.hidden = visible > 0;
    }

    /* ── Compare toggle ── */
    if (toggle) {
      toggle.addEventListener('click', function () {
        compareMode = !compareMode;
        toggle.setAttribute('aria-checked', compareMode ? 'true' : 'false');
        toggle.classList.toggle('is-on', compareMode);
        section.classList.toggle('is-compare-mode', compareMode);
        if (!compareMode) clearAll();
      });
    }

    /* ── Card click (check/uncheck) ── */
    cards.forEach(function (card) {
      var wrap = qs(card, '.pc-card__check-wrap');
      if (!wrap) return;
      wrap.addEventListener('click', function (e) {
        e.preventDefault();
        if (!compareMode) return;
        var id = card.dataset.compareId;
        if (card.classList.contains('is-selected')) {
          removeCard(card, id);
        } else if (selectedIds.length < maxCmp) {
          addCard(card, id);
        }
      });
    });

    function addCard(card, id) {
      card.classList.add('is-selected');
      var chk = qs(card, '.pc-card__check');
      if (chk) chk.checked = true;
      if (selectedIds.indexOf(id) === -1) selectedIds.push(id);
      refreshBar();
    }

    function removeCard(card, id) {
      card.classList.remove('is-selected');
      var chk = qs(card, '.pc-card__check');
      if (chk) chk.checked = false;
      selectedIds = selectedIds.filter(function (x) { return x !== id; });
      refreshBar();
    }

    function clearAll() {
      cards.forEach(function (card) {
        card.classList.remove('is-selected');
        var chk = qs(card, '.pc-card__check');
        if (chk) chk.checked = false;
      });
      selectedIds = [];
      refreshBar();
    }

    function getSelectedCards() {
      return Array.prototype.filter.call(cards, function (c) {
        return c.classList.contains('is-selected');
      });
    }

    /* ── Compare bar ── */
    function refreshBar() {
      if (!bar) return;
      var count = selectedIds.length;

      if (!compareMode || count === 0) {
        bar.hidden = true;
        document.dispatchEvent(new CustomEvent('pc:bar-toggle', { detail: { visible: false } }));
        return;
      }
      bar.hidden = false;
      document.dispatchEvent(new CustomEvent('pc:bar-toggle', { detail: { visible: true } }));

      /* Thumbnails */
      var selected = getSelectedCards();
      var thumbHtml = '';
      for (var i = 0; i < maxCmp; i++) {
        var sc = selected[i];
        if (sc) {
          var src = sc.dataset.compareImg || '';
          thumbHtml += '<div class="pc-bar__thumb">' +
            (src
              ? '<img src="' + esc(src) + '" alt="' + esc(sc.dataset.compareTitle || '') + '" width="44" height="44" loading="lazy">'
              : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>'
            ) +
            '</div>';
        } else {
          thumbHtml += '<div class="pc-bar__thumb-empty"></div>';
        }
      }
      barThumbs.innerHTML = thumbHtml;

      /* Info text */
      var remaining = minCmp - count;
      var infoText  = tpl(selectedTpl, count);
      if (remaining > 0) {
        infoText += ' — ' + tpl(addMoreTpl, remaining);
      }
      barInfo.textContent = infoText;

      /* CTA state */
      if (barCta) barCta.disabled = count < minCmp;
    }

    if (barClear) barClear.addEventListener('click', clearAll);
    if (barCta)   barCta.addEventListener('click',  openPopup);

    /* ── Popup ── */
    function openPopup() {
      if (!popup || selectedIds.length < minCmp) return;
      buildTable();
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = qs(popup, '.pc-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    function closePopup() {
      if (!popup) return;
      popup.hidden = true;
      document.body.style.overflow = '';
      if (barCta) barCta.focus();
    }

    if (popupBackdrop) popupBackdrop.addEventListener('click', closePopup);
    if (popupClose)   popupClose.addEventListener('click',   closePopup);

    if (tableWrap) {
      tableWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.pc-cmp-table__buy-btn');
        if (!btn) return;
        e.preventDefault();
        var href = btn.getAttribute('href');
        closePopup();
        if (href && href !== '#') window.location.href = href;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup && !popup.hidden) closePopup();
    });

    /* ── Table builder ── */
    function buildTable() {
      if (!tableWrap) return;
      var sel = getSelectedCards();
      if (!sel.length) return;

      var rl = rowLabels;
      var html = '<table class="pc-cmp-table" role="table">';

      /* thead: product image + name per column */
      html += '<thead><tr>';
      html += '<th class="pc-cmp-table__hcell pc-cmp-table__hcell--label" scope="col">' + esc(rl.title || 'Product') + '</th>';
      sel.forEach(function (card) {
        var title = card.dataset.compareTitle || '';
        var src   = card.dataset.compareImg   || '';
        html += '<th class="pc-cmp-table__hcell pc-cmp-table__hcell--product" scope="col">';
        html += '<div class="pc-cmp-table__product-card">';
        if (src) {
          html += '<img class="pc-cmp-table__product-img" src="' + esc(src) + '" alt="' + esc(title) + '" width="70" height="70" loading="lazy">';
        } else {
          html += '<div class="pc-cmp-table__product-img-ph">';
          html += '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
          html += '</div>';
        }
        html += '<span class="pc-cmp-table__product-name">' + esc(title) + '</span>';
        html += '</div>';
        html += '</th>';
      });
      html += '</tr></thead>';

      html += '<tbody>';

      /* Core rows: Spec 1, Spec 2 */
      html += textRow(rl.spec1 || 'Home Size', sel, function (c) { return c.dataset.compareSpec1 || '—'; });
      html += textRow(rl.spec2 || 'Capacity',  sel, function (c) { return c.dataset.compareSpec2 || '—'; });

      /* Dynamic extra rows — driven entirely by section settings */
      var extraRows = cfg.extraRows || [];
      for (var ei = 0; ei < extraRows.length; ei++) {
        (function (row) {
          html += textRow(row.label, sel, function (c) {
            return c.dataset['compare' + row.key.charAt(0).toUpperCase() + row.key.slice(1)] || '—';
          });
        })(extraRows[ei]);
      }

      /* Price row */
      html += '<tr role="row">';
      html += '<td class="pc-cmp-table__cell pc-cmp-table__cell--label">' + esc(rl.price || 'Price') + '</td>';
      sel.forEach(function (card) {
        var price   = card.dataset.comparePrice        || '';
        var cmpPrc  = card.dataset.compareComparePrice || '';
        html += '<td class="pc-cmp-table__cell">';
        if (price)  html += '<span class="pc-cmp-table__price-main">'    + esc(price)  + '</span>';
        if (cmpPrc) html += '<span class="pc-cmp-table__price-compare">' + esc(cmpPrc) + '</span>';
        if (!price && !cmpPrc) html += '—';
        html += '</td>';
      });
      html += '</tr>';

      /* Action row */
      html += '<tr role="row">';
      html += '<td class="pc-cmp-table__cell pc-cmp-table__cell--label">' + esc(rl.action || 'Buy Now') + '</td>';
      sel.forEach(function (card) {
        var url  = card.dataset.compareBtnUrl  || '#';
        var text = card.dataset.compareBtnText || 'Shop Now';
        html += '<td class="pc-cmp-table__cell">';
        html += '<a class="pc-cmp-table__buy-btn" href="' + esc(url) + '">' + esc(text);
        html += '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
        html += '</a>';
        html += '</td>';
      });
      html += '</tr>';

      html += '</tbody></table>';
      tableWrap.innerHTML = html;
    }

    function textRow(label, cards, fn) {
      var h = '<tr role="row"><td class="pc-cmp-table__cell pc-cmp-table__cell--label">' + esc(label) + '</td>';
      cards.forEach(function (c) { h += '<td class="pc-cmp-table__cell">' + esc(fn(c)) + '</td>'; });
      return h + '</tr>';
    }

    /* ── Boot ── */
    applyFilter();
    if (compareMode) section.classList.add('is-compare-mode');
  }

  /* ── Bootstrap all sections ── */
  function bootstrap() {
    document.querySelectorAll('.pc-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Shopify theme editor hot-reload */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('.pc-section');
    if (el) initSection(el);
  });

})();
